import { useQuery } from '@tanstack/react-query'
import { ExtendableQueryOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { getForgeToken, isForgeConfigured } from '../../config'
import { ArtifactReviewScope } from '../../forgeApi.types'

export interface ReviewerCapability {
  is_reviewer: boolean
  // which share-types are gated; lets the share dialog frame org/user correctly
  review_scope: ArtifactReviewScope
}

// Whether the current user may approve/decline shared widgets (+ the review
// scope). A hint for showing/hiding the review UI — forge still enforces
// authorization on every review action regardless.
const getReviewerCapability = async (): Promise<ReviewerCapability> => {
  const response = await forgeApi.get<Partial<ReviewerCapability>>(
    '/api/v1/artifacts/reviewer'
  )
  return {
    is_reviewer: Boolean(response.data?.is_reviewer),
    review_scope: (response.data?.review_scope as ArtifactReviewScope) || 'any'
  }
}

const REVIEWER_CAPABILITY_QUERY_KEY = 'forge-reviewer-capability'

export const useReviewerCapabilityQuery = (
  options?: ExtendableQueryOptions<ReviewerCapability>
) => {
  const enabled = isForgeConfigured() && Boolean(getForgeToken())
  return useQuery({
    queryKey: [REVIEWER_CAPABILITY_QUERY_KEY],
    queryFn: getReviewerCapability,
    enabled,
    // reviewer membership rarely changes; avoid refetching on every mount
    staleTime: 5 * 60 * 1000,
    ...options
  })
}
